import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'libs/styled';
import AccordionHeaderFAQ from './AccordionHeaderFAQ';

const Wrapper = styled('div')`
    background-color: var(--color-neutrals-100);
`;

const AnimationWrapper = styled('div')`
    display: grid;
    grid-template-rows: 0fr;
    transition: all 250ms;

    .content {
        overflow: hidden;
        width: 100%;
        max-width: 631px;
        ul,
        ol {
            list-style-position: outside;
            margin-left: 0;
            padding-left: 40px;

            > * + * {
                margin-top: 0.5em;
            }
        }

        ul {
            margin-top: 0.5em;
            list-style-type: unset;
        }

        ol {
            margin-top: 0.5em;
            list-style-type: lower-latin;
        }
    }

    &[data-show='true'] {
        grid-template-rows: 1fr;
        background-color: var(--background-color-default);
    }
`;

const AccordionFAQ = ({ active = null, label, children, ...props }) => {
    const [show, setShow] = useState(active);

    if (!children) {
        return null;
    }

    const toggleShow = useCallback(() => {
        setShow((active) => !active);
    }, []);

    return (
        <Wrapper {...props}>
            <AccordionHeaderFAQ label={label} active={show} onClick={toggleShow} />
            <AnimationWrapper data-show={show}>
                <div className="content">{children}</div>
            </AnimationWrapper>
        </Wrapper>
    );
};

AccordionFAQ.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node.isRequired,
    label: PropTypes.array,
};

AccordionFAQ.defaultProps = {
    active: false,
    label: '',
};

export default AccordionFAQ;
